import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { cn } from '../../utils/classnames.js';
import AvatarLogo from '../avatar-logo/index.js';
import Icon from '../icon/index.js';
function AnimatedLogo({ iconName, iconSize = 80, width = 160, className, animationDelay = 200, }) {
    const [expanded, setExpanded] = useState(false);
    useEffect(() => {
        const timeout = setTimeout(() => setExpanded(true), animationDelay);
        return () => {
            clearTimeout(timeout);
        };
    }, [animationDelay]);
    return (_jsxs("div", { style: {
            height: `${iconSize}px`,
            width: `${expanded ? width : iconSize}px`,
        }, className: cn('ui-relative ui-flex ui-justify-between ui-rounded-full ui-bg-metallic-gradient ui-transition-all ui-duration-300', className), children: [_jsx(AvatarLogo, { size: iconSize, className: cn('ui-z-[1]') }), _jsx("div", { className: cn('ui-absolute ui-right-0 ui-z-[0] ui-flex ui-flex-shrink-0 ui-items-center ui-justify-center ui-rounded-full ui-bg-black theme-dark:ui-bg-white'), style: {
                    width: `${iconSize}px`,
                    height: `${iconSize}px`,
                    transform: `scale(${expanded ? 1 : 0.9})`,
                }, children: _jsx(Icon, { size: iconSize * 0.375, className: cn('ui-text-white theme-dark:ui-text-black'), name: iconName }) })] }));
}
export default AnimatedLogo;
